<template>
  <!--首页-->
  <div class="home-page">
    <!--头部-->
    <a-card :loading="loading">
      <a-row type="flex" :gutter="[0,10]" align="middle">
        <!--个人信息-->
        <a-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
          <a-row type="flex" align="middle">
            <a-avatar
              class="avatar"
              size="large"
              :src="(user && user.avatar) || avatar"
              style="width: 82px;height: 82px"
            />
            <div class="information">
              <div class="personal">你好，{{ (user && user.name) || "管理员" }}</div>
              <div class="role">
                <!-- <span>{{ (user && user.adminRole) | role }}</span> -->
                <!-- <span>{{ (user)}}</span> -->
                <span v-if="company">所属公司| {{ company }}</span>
              </div>
            </div>
          </a-row>
        </a-col>
        <!--订单数量-->
        <a-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
          <a-row class="Statistics">
            <a-col :xs="10" :sm="10" :md="6" :lg="4" :xl="3">
              <div style="color:#FF3E0A" v-if="this.isShow">
                <div>新订订单</div>
                <div>{{num.add}}</div>
              </div>
            </a-col>
            <a-col :xs="8" :sm="10" :md="6" :lg="4" :xl="3">
              <div v-if="this.isShow">
                <div>已读订单</div>
                <div>{{num.read}}</div>
              </div>
            </a-col>
            <a-col :xs="10" :sm="10" :md="6" :lg="4" :xl="3">
              <div v-if="this.isShow">
                <div>生产中订单</div>
                <div>{{num.madeing}}</div>
              </div>
            </a-col>
            <a-col :xs="12" :sm="10" :md="6" :lg="4" :xl="4">
              <div v-if="this.isShow">
                <div>生产完成订单</div>
                <div>{{num.complete}}</div>
              </div>
            </a-col>
            <a-col :xs="10" :sm="10" :md="6" :lg="4" :xl="3">
              <div v-if="this.isShow">
                <div>运输中订单</div>
                <div>{{num.transit}}</div>
              </div>
            </a-col>
            <a-col :xs="10" :sm="10" :md="6" :lg="4" :xl="3">
              <div v-if="this.isShow">
                <div>已收货订单</div>
                <div>{{num.deliveriesTaked}}</div>
              </div>
            </a-col>
            <a-col :xs="10" :sm="10" :md="6" :lg="4" :xl="3">
              <div v-if="this.isShow">
                <div>已完成订单</div>
                <div>{{num.finish}}</div>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>

    <!--订单-->
    <ak-model-filter-card model="indexOrder" @search="search" @reset="reset" />
    <ak-model-card model="indexOrder" :page.sync="page" :filters="filters" :perPage="30" />

    <!-- <div v-if="adminRole !== 'sale' && cardShow"> -->
    <div v-if=" cardShow">
      <a-modal v-model="visible" footer @ok="handleOk" @cancel="handleCancel" :width="960">
        <view-formila :formulas="formulas" :title="title" />
      </a-modal>
    </div>

    <div v-if="!cardShow">
      <a-modal v-model="visible" footer :title="`${title}配方`" @ok="visible=false" :width="960">
        <div class="formula" v-for="(item,index) in formulasData" :key="index">
          <div class="formulaF">
            <span v-show="item.type==='parts'">半成品：</span>
            <span v-show="item.type==='rawMaterial'">原材料：</span>
            {{item.data.name}} {{ item.weight }}KG {{ item.percentage }}%配比
          </div>
          <div v-if="item.data.formula" class="formulaSon">
            <div
              v-for="(itm,idx) in item.data.formula"
              :key="idx"
            >{{ itm.rawMaterial.name }}&nbsp;&nbsp;&nbsp;&nbsp;{{ itm.weight + "kg" }}</div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import defaultAvatar from '@/assets/images/avatar.png'
import store from '@/store/index'
import ViewFormila from '../core/components/viewFormula'
// import PageHeader from '@/components/PageHeader/PageHeader'
import NP from 'number-precision'
import Bus from '../assets/js/eventBus'

export default {
  components: {
    // 's-pageheader': PageHeader,
    ViewFormila
  },
  data () {
    return {
      isGdNumber: false,
      isShow: true,
      loading: false,
      avatar: defaultAvatar,
      company: '',
      page: 1,
      cardShow: true,
      filters: {},
      title: '订单',
      // adminRole: store.state.user.adminRole,
      formulas: [],
      formulasData: [],
      visible: false,
      num: {
        add: 0,
        read: 0,
        finish: 0,
        madeing: 0,
        transit: 0,
        deliveriesTaked: 0,
        complete: 0,
      }
    }
  },
  filters: {
    // 管理员身份显示
    role: function (r) {
      let role = {
        admin: '超级管理员',
        sale: '销售经理',
        finance: '财务经理',
        workshop: '车间经理',
        staff: '内勤人员',
        undetermined: '待定身份'
      }
      return role[r]
    }
  },
  computed: {
    ...mapState(['user']),
    indexUpdate () {
      return store.state.indexUpdate
    },
  },
  watch: {
    indexUpdate: function (newd, old) {
      if (newd === 'yes') {
        this.gdnumber()
      }
    }
  },
  created () {
    if (window.outerWidth > 1200) {
      // pc端左侧展示
      this.cardShow = true
    } else {
      // 移动端弹窗
      this.cardShow = false
    }
    console.log('user', store.state.user)
  },
  async mounted () {
    this.issShow()
    this.getCompany()
    this.gdnumber()
    Bus.$on('formula', this.onFormula)
    Bus.$on('indexShowModal', this.indexShowModal)
  },
  beforeDestroy () {
    Bus.$off('formula', this.onFormula)
  },
  methods: {
    search (filters) {
      // filters是组件自动生成的where搜索参数
      this.page = 1
      this.filters = filters // 修改modelTable的查询条件会自动触发刷新
    },
    reset () {
      this.where = {}
      this.page = 1
      this.filters = {}
    },
    issShow () {
      if (this.isGdNumber) {
        if (this.num.add === 0 && this.num.read === 0 && this.num.finish === 0 && this.num.madeing === 0 && this.num.transit === 0 && this.num.deliveriesTaked === 0 && this.num.complete === 0) {
          this.isShow = false
        }
      } else {
        this.isShow = false
      }
    },
    async gdnumber () {
      let where = {}
      // if (store.state.user && store.state.user.adminRole === 'sale') {
      //   // 销售经理
      //   where.userid = store.state.user.objectId
      // }
      // if (store.state.user && store.state.user.adminRole === 'workshop') {
      //   // 车间经理
      if (store.state.user && !store.state.user.authority.order.view) {
        where.objectId = '{ $exist: false }'
      }
      if (store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
      if (store.state.user.allShopManagements === 'Yes') { } else {
        where.shopManagementid = {
          $in: store.state.user.shopManagements
        }
      }
      // }
      // 查询人数
      const res = await this.$tkParse.group('/classes/Order', 'status', {
        params: {
          select: {
            count: { // 该组人数
              $sum: 1
            }
          },
          where: where
        }
      })

      for (let i in res.data.results) {
        let data = res.data.results[i]
        this.num[data.objectId] = data.count
      }
      store.commit('setIndexUpdate', 'no')
      this.isGdNumber = true
      this.isShow = true
      this.issShow()
    },
    async getCompany () {
      let company = await this.$modelAjax
        .getData('company', {
          params: {
            where: { objectId: this.user.company }
          }
        })
        .catch(e => { })
      if (company.results.length) {
        this.company = company.results[0].name
      }
    },
    // 获取原材料
    async getRawMaterial (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/rawMaterial/${data.rawMaterial}`
      )
      return res
    },
    // 获取半成品
    async getParts (data) {
      const { data: res } = await this.$tkParse.get(
        `/classes/parts/${data.parts}`
      )
      return res
    },
    async onFormula (payload) {
      this.formulas = payload.finishProductid.formula
      this.title = payload.finishProductid.name
      if (window.outerWidth < 1200) {
        let allWeight = 0
        for (let i in this.formulas) {
          allWeight = NP.plus(allWeight, this.formulas[i].weight)
          if (this.formulas[i].parts) {
            const res = await this.getParts(this.formulas[i])
            this.formulasData.push({
              data: res,
              weight: this.formulas[i].weight,
              type: 'parts'
            })
          } else {
            const res = await this.getRawMaterial(this.formulas[i])
            this.formulasData.push({
              data: res,
              weight: this.formulas[i].weight,
              type: 'rawMaterial'
            })
          }
        }
        for (const item of this.formulasData) {
          this.$set(
            item,
            'percentage',
            NP.times(Number(NP.divide(item.weight, allWeight).toFixed(4)), 100)
          )
        }
        this.visible = true
      }
    },
    indexShowModal () {
      this.visible = true
    },
    handleOk () {
      this.visible = false
      this.$emit('complete', 'cancel')
    },
    handleCancel () {
      this.$emit('complete')
    }
  }
}
</script>
<style scoped lang="scss">
.Statistics{
  text-align: center;
}
.home-page {
  .information {
    margin-left: 20px;
    .personal {
      font-size: 24px;
      /*font-weight: bold;*/
      color: rgba(33, 33, 33, 1);
    }
    .role {
      font-size: 16px;
      color: rgba(102, 102, 102, 1);
    }
  }
}
.formula{
  border-bottom: 1px solid #e5e7ea;
  .formulaF{
  padding:10px 0;
  }
  .formulaSon{
    background-color: rgb(249, 249, 249);
    padding: 10px 20px;
  }
}
</style>
